import * as yup from 'yup'
export default function createFormSchema({ notEditInfo, isSpgeCF, isSpgeF, samplePassword, isServiceManager }) {
  const phoneRegex = /^[0-9]+$/

  const spongeRschema = {
    account_name: isServiceManager ? yup.string() : yup.string().required(), //계좌 출금 정보
    account_phone_no: isServiceManager
      ? yup.string()
      : yup
          .string()
          // 숫자만 입력해주세요.
          .required('필수정보입니다.')
          .matches(phoneRegex, '숫자만 입력해주세요.')
          .min(10, '전화번호 10~11자를 입력해주세요.')
          .max(11, '전화번호 10~11자를 입력해주세요.'),
    account_no: isServiceManager
      ? yup.string()
      : yup
          .string()
          .required('필수정보입니다.')
          .matches(/^[0-9]+$/, '숫자만 입력해주세요.'),

    account_jumin_biz_no: isServiceManager
      ? yup.string()
      : yup
          .string()
          .required('필수정보입니다.')
          .matches(/^[0-9]+$/, '숫자만 입력해주세요.')
          .required('Required'),
    bank_code: isServiceManager ? yup.string() : yup.string().required('필수정보입니다.')
  }

  const shopFormSchema = {
    shop_name: yup.string().required('필수정보입니다.')
  }
  const transformPasswordToSample = (curr, orig) => (orig.split('*').length - 1 === orig.length ? samplePassword : curr)

  const bizNoSchema = {
    biz_no: yup //사업자 정보
      .string()
      .required('필수정보입니다.')
      .matches(/^(?:\d{10}|\d{10}-\d{4})$/, '사업자번호는 10자리 숫자 또는 10자리 숫자 뒤에 -와 4자리 숫자가 필요합니다.')
      .min(10, '사업자번호 10자를 입력해주세요.')
      .max(15, '사업자번호 10-15자를 입력해주세요.')
  }
  const regularFormSchema = {
    owner_name: yup.string().required('필수정보입니다.'),
    owner_phone_no: yup
      .string()
      .required('필수정보입니다.')
      .matches(phoneRegex, '숫자만 입력해주세요.')
      .min(10, '전화번호 10~11자를 입력해주세요.')
      .max(11, '전화번호 10~11자를 입력해주세요.'),
    //신청자 확인 및 약관 동의
    apply_phone_no: yup
      .string()
      .matches(phoneRegex, '숫자만 입력해주세요.')
      .min(10, '전화번호 10~11자를 입력해주세요.')
      .max(11, '전화번호 10~11자를 입력해주세요.'),

    apply_name: yup.string(),
    account_relation: yup.string(),
    agree_yn: yup.boolean().required('필수정보입니다.').oneOf([true], '필수정보입니다.'),

    different_apply_customer: yup.string().required(),
    id: yup.string().required('필수정보입니다.').min(5, '5~15자리를 입력해주세요.').max(15, '5~15자리를 입력해주세요.'),
    password: yup
      .string()
      .required('필수정보입니다.')
      .min(5, '5~20자')
      .max(20, '5~20자')
      .matches(/^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{5,20}$/, '비밀번호 형식이 올바르지 않습니다')
      .transform(transformPasswordToSample),
    confirmPassword: yup
      .string()
      .required('필수정보입니다.')
      .min(5, '5~20자')
      .max(20, '5~20자')
      .matches(/^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{5,20}$/, '비밀번호 형식이 올바르지 않습니다')
      .transform(transformPasswordToSample)
  }

  const agreeYn2Schema = {
    agree_yn2: yup.boolean().required('필수정보입니다.').oneOf([true], '필수정보입니다.')
  }

  const agreeYn3Schema = {
    agree_yn3: yup.boolean().required('필수정보입니다.').oneOf([true], '필수정보입니다.')
  }

  const spgeCFchema = {
    ...agreeYn2Schema,
    ...agreeYn3Schema
    // otp: yup
    //   .string()
    //   .required(' 대표자 휴대폰번호를 인증해주세요.')
    //   .min(6, ' 대표자 휴대폰번호를 인증해주세요.')
    //   .max(6, ' 대표자 휴대폰번호를 인증해주세요.')
    //   .matches(/^[0-9]+$/, ' 대표자 휴대폰번호를 인증해주세요.')
  }
  const spgeFschema = {
    ...agreeYn2Schema,
    upload_file: yup.mixed().required('필수정보입니다.').nonNullable('필수정보입니다.'),
    contact_manager_name: yup.string().required('필수정보입니다.'),
    franchisee_name: yup.string().required('필수정보입니다.'),
    contact_manager_email: yup
      .string()
      .required('필수정보입니다.')
      .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, '이메일형식이 올바르지 않습니다.')
  }
  if (notEditInfo) {
    return yup.object({
      ...bizNoSchema
    })
  }

  return yup.object({
    ...bizNoSchema,
    ...regularFormSchema,
    ...(!isSpgeF ? shopFormSchema : {}),
    ...(isSpgeCF ? spgeCFchema : {}),
    ...(isSpgeF ? spgeFschema : {}),
    ...(!isSpgeCF && !isSpgeF ? spongeRschema : {})
  })
}
